// OrgPendingPage — port of auth/org_pending.html. Awaiting org-admin approval. email via ?email.
import { Link, useSearchParams } from 'react-router-dom';
import AuthShell, { AuthCardHeader } from '@/components/auth/AuthShell';
import { paths } from '@/routes/paths';

export default function OrgPendingPage() {
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';

  return (
    <AuthShell
      pageClass="pending-page recovery-page"
      cardClass="pending-card"
      left={
        <div className="auth-content recovery-content">
          <h2 className="auth-brand-topline">Membership Pending</h2>
          <h1 className="name-text-img auth-brand-line">Quralyst</h1>
          <p>
            Your request has been submitted to your organization's administrator.
            <br />
            You will receive full workspace access once approved.
          </p>
        </div>
      }
      cardHeader={
        <AuthCardHeader
          title="Awaiting Approval"
          right={
            <>
              Already approved?
              <br />
              <Link to={paths.auth.login}>Sign in</Link>
            </>
          }
        />
      }
    >
      <div className="pending-status">
        <span className="pending-status-dot" />
        Awaiting Org Admin Approval
      </div>

      <p className="pending-intro">
        Your administrator must approve your membership before you can access your Quralyst
        workspace.
      </p>

      {email && (
        <div className="pending-email">
          <p className="pending-email-label">Registered account</p>
          <p className="pending-email-value">{email}</p>
        </div>
      )}

      <ul className="pending-steps">
        <li>
          <span>1</span>
          <div>Your organization administrator has been notified of your registration.</div>
        </li>
        <li>
          <span>2</span>
          <div>Once approved, you will receive a confirmation email.</div>
        </li>
        <li>
          <span>3</span>
          <div>Sign in with your registered credentials to access your workspace.</div>
        </li>
      </ul>

      <p className="pending-note">Please check your inbox and spam folder for updates.</p>

      <div className="auth-success-actions">
        <Link to={paths.auth.login} className="auth-button auth-return-link">
          Return to Sign In
        </Link>
      </div>
    </AuthShell>
  );
}
